import router from 'next/router';
import fetchNext from '@features/api/fetchNext';
import getPublicEnv from '@utils/getPublicEnv';
class NextCategoriesApi {
  private endpoints = {
    getMarketingCategory: (categoryId: number) => `category/${categoryId}`,
    getMarketingCategoryProducts: (categoryId: number) => `category/${categoryId}/products`,
    getArrangementProductProducts: (arrangementProductId: number) => `category/arrangement-product-products/${arrangementProductId}`
  };
  private static getLocale() {
    const isServerSide = typeof window === 'undefined';
    if (isServerSide) return process.env.DEFAULT_LOCALE;
    const {
      locale
    } = router;
    return locale || getPublicEnv('NEXT_PUBLIC_DEFAULT_LOCALE');
  }
  public async getMarketingCategory(categoryId: number) {
    const method = 'GET';
    const {
      json
    } = await fetchNext(this.endpoints.getMarketingCategory(categoryId), {
      method
    }, NextCategoriesApi.getLocale());
    return json;
  }
  public async getMarketingCategoryProducts(categoryId: number, query) {
    const method = 'POST';
    const {
      json
    } = await fetchNext(`${this.endpoints.getMarketingCategoryProducts(categoryId)}`, {
      method,
      body: JSON.stringify(query)
    }, NextCategoriesApi.getLocale());
    return {
      pagination: json.query.pagination,
      filters: json.query.filters,
      sorting: {
        order: json.query.sorting.order,
        current: json.query.sorting.currentAspect,
        available: [json.query.sorting.availableAspects]
      },
      products: json.data
    };
  }
  public async getArrangementProductProducts(arrangementProductId: number) {
    const method = 'GET';
    const resonse = await fetchNext(`${this.endpoints.getArrangementProductProducts(arrangementProductId)}`, {
      method
    }, NextCategoriesApi.getLocale());
    return resonse?.json ?? [];
  }
}
export default new NextCategoriesApi();